import { APIConfig } from "@/lib/api";
import { ApiError } from "@/lib/api/api-error";
import { request as __request } from "@/lib/api/request";
import {
  type UploadFileConfirmPayload,
  type UploadFileConfirmResponse,
  uploadFileConfirmResponseSchema,
  uploadRequestSchema,
} from "./types/uploads";

export class UploadService {
  static async createUploadRequest(files: File[]) {
    try {
      return await __request(
        APIConfig,
        {
          method: "POST",
          url: "/api/v1/orders/uploads/",
          formData: {
            files,
          },
        },
        uploadRequestSchema,
      );
    } catch (error) {
      if (error instanceof ApiError) {
        console.error(
          `[createUploadRequest] API Error: ${error.message} (Status: ${error.status})`,
          error.body,
        );
      } else {
        console.error("[createUploadRequest] Unexpected error:", error);
      }
      throw error;
    }
  }

  static async getUploadRequest(id: string) {
    try {
      return await __request(
        APIConfig,
        {
          method: "GET",
          url: "/api/v1/orders/uploads/{id}/",
          path: {
            id,
          },
        },
        uploadRequestSchema,
      );
    } catch (error) {
      if (error instanceof ApiError) {
        console.error(
          `[getUploadRequest] API Error: ${error.message} (Status: ${error.status})`,
          error.body,
        );
      } else {
        console.error("[getUploadRequest] Unexpected error:", error);
      }
      return null;
    }
  }

  static async confirmFile(
    id: string,
    fileId: string,
    payload: UploadFileConfirmPayload,
  ): Promise<UploadFileConfirmResponse> {
    try {
      return await __request(
        APIConfig,
        {
          method: "POST",
          url: "/api/v1/orders/uploads/{id}/files/{file_id}/confirm/",
          path: {
            id,
            file_id: fileId,
          },
          mediaType: "application/json",
          body: payload,
        },
        uploadFileConfirmResponseSchema,
      );
    } catch (error) {
      if (error instanceof ApiError) {
        console.error(
          `[confirmFile] API Error: ${error.message} (Status: ${error.status})`,
          error.body,
        );
      } else {
        console.error("[confirmFile] Unexpected error:", error);
      }
      throw error;
    }
  }
}
